<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>발송 상세 [{{ sendInfo.sendScnNm }}]</h1>
      </div>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본정보</h2>
      </div>
      <div class="box_flex">
        <div class="cmdp_photo w30">
        <span>
          <img
              v-show="fileSrc !== null"
              :src="fileSrc"
          >
          <img v-show="fileSrc == null" src="@/assets/img/etners-main/aiportal_img.png">
        </span>
      </div>
      <ul class="filter_list user_photo_right mgl20">
        <li>
          <dd>
            <label class="w30">No.</label>
            <ul class="w70">
              <li>{{ sendInfo.itemId }}</li>
            </ul>
          </dd>
          <dd>
            <label class="w30">진행 상태</label>
            <ul>
              <li>
                {{ sendInfo.statusNm }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">등록자</label>
            <ul class="w70">
              <li>
                {{ sendInfo.frstRgstId }} &nbsp; | &nbsp; {{ sendInfo.frstRgstDt}}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">용도</label>
            <ul class="w70">
              <li>
                {{ sendInfo.ppsScnNm }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
           <dd>
            <label class="w30">취급 구분</label>
            <ul class="w70">
              <li> {{ sendInfo.sendScnNm }} </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            &nbsp;
          </dd>
          <dd>
            <label class="w30">특송사</label>
            <ul class="w70">
              <li> {{ sendInfo.shpcScnNm }} </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            &nbsp;
          </dd>
          <dd>
            <label class="w30">운송장 번호</label>
            <ul class="w70">
              <li>
                {{ sendInfo.blNo === null ? '-' : sendInfo.blNo }}
              </li>
            </ul>
          </dd>
        </li>
        <li>

        </li>
      </ul>
      <!-- 최근 일자 상단 표기 -->
      <div class="w40">
        <h3>보관 이력</h3>
        <table class="basic_table" border="0" cellpadding="0" cellspacing="0">
          <colgroup>
            <col class="w25" />
            <col class="w25" />
            <col class="w15" />
            <col class="w35" />
          </colgroup>
          <tbody role="rowgroup">
          <tr role="row">
            <th class="txt_c">현황</th>
            <th class="txt_c">보관 위치</th>
            <th class="txt_c">보관함</th>
            <th class="txt_c">담당자</th>
          </tr>
          <tr role="row" class="k-text-center"  v-if="historyList.length === 0">
            <td class="mgt10" style="width:100%" colspan="4">표시할 데이터가 없습니다.</td>
          </tr>
          <tr v-else v-for="item in historyList">
            <td>{{item.status}}</td>
            <td>{{item.lockerNm}}</td>
            <td>{{item.originId? item.originId : '-'}}</td>
            <td>{{item.userNm}} {{item.frstRgstDt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>임직원 정보[보내는 분]</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>사업장 / 거점</label>
            <ul class="w50">
              <li>
                {{ !!sendInfo.facilityNm ? sendInfo.facilityNm : '-'}} <span class="mgl10">{{ !!sendInfo.areaNm ? sendInfo.areaNm : '-' }}</span>
              </li>
            </ul>
          </dd>
        </li>
         <li>
          <dd>
            <label>발신 부서</label>
            <ul class="w50">
              <li>
                {{ !!sendInfo.sendDept ? sendInfo.sendDept : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            <label>발신</label>
            <ul class="w50">
              <li>
                {{ !!sendInfo.sendNm ? sendInfo.sendNm : '-' }}
              </li>
            </ul>
          </dd>
           <dd>
            <label>사원 번호</label>
            <ul class="w50">
              <li>
                {{ !!sendInfo.sendSabun ? sendInfo.sendSabun : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>전화 번호</label>
            <ul class="w50">
              <li>
                {{ !!sendInfo.sendTel ? sendTel : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>이메일</label>
            <ul class="w50">
              <li>
                {{ !!sendInfo.sendMailAddr ? sendInfo.sendMailAddr : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>대리 발송 여부</label>
            <ul class="w50">
              <li class="w100">
                {{ sendInfo.steadYn === 'Y' ? '대리' : '본인' }}
              </li>
            </ul>
          </dd>
          <dd>
          </dd>
        </li>
        <li>
          <dd>
            <label>발송인</label>
            <ul class="w50">
              <li class="w100">
                {{ !!sendInfo.steadNm ? sendInfo.steadNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>대리 발송인 부서</label>
            <ul class="w50">
              <li class="w100">
                {{ !!sendInfo.steadDept ? sendInfo.steadDept : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <!--상세 정보[보내시는 분]-->
    <send-detail-regi
        v-show="sendInfo.sendScn === '01'"
        ref="sendDetailRegi"
        v-bind:sendInfo="sendInfo"
    >
    </send-detail-regi>
    <send-detail-deli
        v-show="sendInfo.sendScn === '02'"
        ref="sendDetailDeli"
        v-bind:sendInfo="sendInfo"
    >
    </send-detail-deli>
    <send-detail-expr
        v-show="sendInfo.sendScn === '03'"
        ref="sendDetailExpr"
        v-bind:sendInfo="sendInfo"
    >
    </send-detail-expr>

    <!--하단 버튼-->
    <div class="button_area w70">
      <ul>
        <li v-if="(sendInfo.status !== '05' && sendInfo.status !== '99' && sendInfo.status !== '98')" class="w10">
          <button class="large_btn dgray" @click="sendDelete">삭제</button>
        </li>
        <li v-if="(sendInfo.status !== '00' && sendInfo.status !== '05' && sendInfo.status !== '99' && sendInfo.status !== '98')" class="w10">
          <button class="large_btn green" @click="sendUpdate">수정</button>
        </li>
        <li class="w10 mgr20">
          <button class="large_btn" @click="redirectToList">목록</button>
        </li>

        <li v-if="sendInfo.status === '00'" class="w10">
          <button class="large_btn gray" @click="openStatusUpdate('98')">예약 취소</button>
        </li>
        <li class="w10" v-show="sendInfo.status === '00' || sendInfo.status === '01' || sendInfo.status === '04'">
          <button class="large_btn orange" @click="openStatusUpdate('02')">물품 접수</button>
        </li>
        <li class="w10" v-if="(sendInfo.status === '01' || sendInfo.status === '02' || sendInfo.status === '04') && !!!sendInfo.lockerCellId">
          <button class="large_btn gray" @click="openStatusUpdate('05')">발신 취소</button>
        </li>
        <li class="w10" v-if="sendInfo.status === '01' && !!!sendInfo.lockerCellId">
          <button class="large_btn gray" @click="openStatusUpdate('04')">보류</button>
        </li>
        <li class="w10" v-show="sendInfo.status === '02' && sendInfo.storageType === '02'">
          <button class="large_btn orange" @click="openStatusUpdate('99')">배송사 전달</button>
        </li>
      </ul>
    </div>

    <!--상태 변경 팝업-->
    <required-info-for-regi
        ref="requiredInfoForRegiRef"
        :title="'배송사 전달'"
        :sendInfo="sendInfo"
        @getInfoForRegi="getStatusUpdateData"
    ></required-info-for-regi>
    <required-info-for-deli
        ref="requiredInfoForDeliRef"
        :title="'배송사 전달'"
        :propsSendInfo="sendInfo"
        @getInfoForDeli="getInfoForDeli"
    ></required-info-for-deli>
    <required-info-for-expr
        ref="requiredInfoForExprRef"
        :title="'배송사 전달'"
        :propsSendInfo="sendInfo"
        @getInfoForExpr="getInfoForExpr"
    ></required-info-for-expr>
    <zone-info-window
        ref="zoneInfoWindowRef"
        :propsSendInfo="sendInfo"
        @getZoneInfo="getZoneInfo"
    ></zone-info-window>
    <contact-info-window
        ref="contactInfoWindowRef"
        :propsSendInfo="sendInfo"
        @getMailAddr="getMailAddr"
    ></contact-info-window>
  </section>
</template>
<script>

import ManageSendList from "@/views/web/kiosk/logistics/send/SendList";
import SendDetailRegi from "@/components/send/SendDetailRegi";
import SendDetailDeli from "@/components/send/SendDetailDeli";
import SendDetailExpr from "@/components/send/SendDetailExpr";

import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import SendSave from "@/views/web/kiosk/logistics/send/SendSave";

import RequiredInfoForRegi from "@/components/send/RequiredInfoForRegi";
import RequiredInfoForDeli from "@/components/send/RequiredInfoForDeli";
import RequiredInfoForExpr from "@/components/send/RequiredInfoForExpr";
import ZoneInfoWindow from "@/components/send/ZoneInfoWindow";
import ContactInfoWindow from "@/components/send/ContactInfoWindow";

import EtnersParseUtil from "@/common/etners.parse.util";
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "SendDetail",
  components: {SendSave, SendDetailRegi, SendDetailDeli, SendDetailExpr, RequiredInfoForRegi, RequiredInfoForExpr, RequiredInfoForDeli,
    ZoneInfoWindow, ContactInfoWindow},
  created () {
    const vm = this
    vm.getSendDetail()
    vm.getHistoryList()
  },
  computed: {
    receiveAddrWithPostNo () {
      const vm = this
      const receivePost = vm.sendInfo.receivePost
      const receiveAddr = vm.sendInfo.receiveAddr

      if(receivePost !== null && receiveAddr !== null){
        return `(${receivePost}) ${receiveAddr}`
      }else{
        return ''
      }
    },
    sendTel () {
      return EtnersParseUtil.convertTelNo(this.sendInfo.sendTel)
    },
  },
  methods: {
    getSendDetail () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.$route.params.sendId,
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendDetail.json`

      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus

        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        const resultData = response.data.resultData

        vm.sendInfo = resultData
        if(resultData.fileInfo !== null){
          vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
        }

        // 대리발송 여부 체크
        if (vm.sendInfo.steadYn === 'N') {
          vm.sendInfo.steadNm = null
          vm.sendInfo.steadDept = null
          vm.sendInfo.steadTel = null
          vm.sendInfo.steadMailAddr = null
        }
      })

    },
    openStatusUpdate (newStatus) {
      const vm = this
      const refs = vm.$refs
      // (예약 -> 예약 취소, 물품 접수) 케이스 제외하고 사업장 일치 여부 체크
      if(!(vm.sendInfo.status === '00' && (newStatus === '02' || newStatus === '98'))){
        if (!vm.isSU && vm.sendInfo.facility !== vm.loginUserData.facility) {
          kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
          return
        }
      }

      if (EtnersCommonUtil.isNotEmpty(vm.sendInfo.lockerCellId)) {
        kendo.alert('무인보관함에 보관중인 물품은 상태 변경이 불가능합니다.')
        return
      } else if (vm.sendInfo.sendScn === '01' && vm.sendInfo.storageType === '01') {
        // 등기의 경우, lockerCellId는 항상 null이기때문에, storageType 으로 보관함 여부 따져야 한다.
        kendo.alert('무인보관함에 보관중인 물품은 상태 변경이 불가능합니다.')
        return
      }

      // 값 세팅 (팝업 이후 로직을 위해서)
      vm.newStatus = newStatus
      const oldStatus = vm.sendInfo.status
      if (oldStatus === '00' && newStatus === '98') {
        // 예약 -> 예약 취소
        vm.updateReserveCancel()
      } else if (oldStatus === '00' && newStatus === '02') {
        // 예약 -> 물품 접수
        refs.zoneInfoWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
      } else if (oldStatus === '01' && newStatus === '02') {
        // 키오스크 등록 -> 물품 접수
        vm.getStatusUpdateData(vm.sendInfo.blNo, vm.sendInfo.cost)
      } else if (oldStatus === '01' && newStatus === '05') {
        // 키오스크 등록 -> 발신 취소
        refs.contactInfoWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
      } else if (oldStatus === '01' && newStatus === '04') {
        // 키오스크 등록 -> 보류
        refs.contactInfoWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
      } else if (oldStatus === '02' && newStatus === '05') {
        // 물품 접수 -> 발신 취소
        refs.contactInfoWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
      } else if (oldStatus === '02' && newStatus === '99') {
        // 물품 접수 -> 배송사 전달
        const sendScn = vm.sendInfo.sendScn
        if (sendScn === '01') {
          refs.requiredInfoForRegiRef.$refs.kendoWindowRef.kendoWidget().center().open()
        } else if (sendScn === '02') {
          refs.requiredInfoForDeliRef.$refs.kendoWindowRef.kendoWidget().center().open()
        } else if (sendScn === '03') {
          refs.requiredInfoForExprRef.$refs.kendoWindowRef.kendoWidget().center().open()
        }
      } else if (oldStatus === '04' && newStatus === '05') {
        // 보류 -> 발신 취소
        refs.contactInfoWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
      } else if (oldStatus === '04' && newStatus === '02') {
        // 보류 -> 물품 접수
        vm.getStatusUpdateData(vm.sendInfo.blNo, vm.sendInfo.cost)
      }
    },
    callIlyangApi (weight) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/solution/openApi/ilyangLogis.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        runTimeMode: (process.env.NODE_ENV === 'production') ? 'PROD' : 'DEV',
        logisInfo: {
          ilySeqNo: '1234',
          ilyAwbNo: vm.sendInfo.blNo,
          ilySndName: '이트너스',
          ilySndTel1: vm.sendInfo.sendTel,
          ilySndZip: vm.sendInfo.sendPostNo, // 보내는 사람 우편번호
          ilySndAddr: vm.sendInfo.sendAddr, // 보내는 사람 주소
          ilyRcvName: vm.sendInfo.receiveNm,
          ilyRcvTel1: vm.sendInfo.receiveTel,
          ilyRcvZip: vm.sendInfo.receivePost,
          ilyRcvAddr: vm.sendInfo.receiveAddr,
          ilyBoxQty: '1',
          ilyBoxWgt: weight
        }
      }

      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            reject()
          }
          const resultData = response.data.resultData
          if(resultData.head.returnCode !== 'R0'){
            kendo.alert('<p style="text-align:center;">일양 로지스에 데이터를 전달하지 못했습니다.<br>시스템 관리자에게 문의해주세요.</p>')
            reject()
          } else {
            // api 호출 오류 시 logisticsResultData에 담겨 온다. -> R0로 받았는데도 logisticsResultData가 넘어온다...;;
            // R0는 통신 상태를 나타내는 것이고, body가 있다면 오류가 맞다.
            // weight 가 빠져서 나는 오류였음.
            if(resultData.body.logisticsResultData.length > 0) {
              kendo.alert('<p style="text-align:center;">일양 로지스에 데이터를 전달하지 못했습니다.<br>시스템 관리자에게 문의해주세요.</p>')
              reject()
            } else {
              resolve()
            }
          }
        })
      })
    },
    callUpdateBlNoStatusApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/solution/openApi/updateBlNoStatus.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId,
        type: "API"
      }
      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            reject()
          }
          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert('<p style="text-align:center;">일양 로지스에 데이터를 전달하지 못했습니다.<br>시스템 관리자에게 문의해주세요.</p>')
            reject()
          } else {
            resolve()
          }
        })
      })
    },
    getInfoForDeli (weight, sendMailAddr) {
      const vm = this
      if (!(!!vm.sendInfo.sendPostNo && !!vm.sendInfo.sendAddr && !!vm.sendInfo.sendAddrDtl)) {
        kendo.alert('<p style="text-align:center;">현재 발신 주소가 지정되어 있지 않습니다.<br> 시스템 관리자에게 문의해주세요.</p>')
        return
      }

      kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {

        if (vm.sendInfo.ilyangBlNoYn === 'Y') {
          // 1. 일양 api 호출
          vm.callIlyangApi(weight).then(() => {
            // 2. blNo 업데이트 api 호출
            vm.callUpdateBlNoStatusApi()
          }).then(() => {
            // 3. 상태 업데이트 api 호출
            const info = {
              sendMailAddr: sendMailAddr,
              weight: weight,
            }
            vm.callSendStateChange(info)
          }).then(() => {
            vm.redirectToList()
          }).catch(() => {
            // 새로고침
            vm.getSendDetail()
          })
        } else {
          const info = {
            sendMailAddr: sendMailAddr,
            weight: weight,
          }
          vm.callSendStateChange(info).then(() => {
            vm.redirectToList()
          }).catch(() => {
            vm.getSendDetail()
          })
        }
      })

        // // 1. 일양 api 호출
        // vm.callIlyangApi(weight)
        //     .then(() => {
        //       // 2. blNo 업데이트 api 호출
        //       vm.callUpdateBlNoStatusApi()
        //     })
        //     .then(() => {
        //       // 3. 상태 업데이트 api 호출
        //       const info = {
        //         sendMailAddr: sendMailAddr,
        //         weight: weight,
        //       }
        //       vm.callSendStateChange(info)
        //     })
        //     .then(() => {
        //       vm.redirectToList()
        //     })
        // }).catch(() => {
        //   // 새로고침
        //   vm.getSendDetail()
        // })
    },
    callSendStateChange(info) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendStateChange.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId,
        sendScn: vm.sendInfo.sendScn,
        sendMailAddr: info.sendMailAddr,
        newStatus: vm.newStatus, // 상태 변경 이후 상태 코드
        blNo: vm.sendInfo.blNo,
        cost: vm.sendInfo.cost,
        weight: info.weight
      }
      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            reject()
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            reject()
          } else {
            if (EtnersCommonUtil.isNotEmpty(info.sendMailAddr)) {
              if (vm.sendInfo.ilyangBlNoYn === 'Y') {
                kendo.alert('<p style="text-align: center;">배송사 전달 확인 메일 발송 후 <br> 정상적으로 일양 로지스에 물품 정보를 전달하였습니다.</p>')
                resolve()
              } else {
                kendo.alert('<p style="text-align: center;">배송사 전달 확인 메일 발송 후 <br> 정상적으로 상태 변경되었습니다.</p>')
                resolve()
              }
            } else {
              if (vm.sendInfo.ilyangBlNoYn === 'Y') {
                kendo.alert('정상적으로 일양 로지스에 물품 정보를 전달하였습니다.')
                resolve()
              } else {
                kendo.alert('상태 변경 되었습니다.')
                resolve()
              }
            }
          }
        })
      })
    },
    getInfoForExpr (info) {
      const vm = this
      kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {

        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendStateChange.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          sendId: vm.sendInfo.sendId,
          sendScn: vm.sendInfo.sendScn,
          newStatus: vm.newStatus,
          sendMailAddr: info.sendMailAddr,
          lockerId: vm.sendInfo.lockerId,
        }
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          } else if (EtnersCommonUtil.isNotEmpty(info.sendMailAddr)) {
            kendo.alert('배송사 전달 확인 메일 발송 후 상태 변경 되었습니다.')
            vm.redirectToList()
          } else {
            kendo.alert('상태 변경 되었습니다.')
            vm.redirectToList()
          }
        })
      }).fail(() => {
            vm.getSendDetail()
          })
    },
    getZoneInfo (zoneInfo) {
      const vm = this
      kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {

        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendStateChange.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          sendId: vm.sendInfo.sendId,
          sendScn: vm.sendInfo.sendScn,
          newStatus: vm.newStatus,
          facility: zoneInfo.facility,
          area: zoneInfo.area,
          lockerId: zoneInfo.lockerId,
        }

        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false

          } else {
            kendo.alert('상태 변경 되었습니다.')

            // 목록으로 리다이렉트
            vm.redirectToList()
          }
        })
      })
          .fail(() => {
            // 새로고침
            vm.getSendDetail()
          })
    },
    getMailAddr (info) {
      const vm = this
      kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {

        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendStateChange.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          sendId: vm.sendInfo.sendId,
          sendScn: vm.sendInfo.sendScn,
          newStatus: vm.newStatus,
          sendMailAddr: info.sendMailAddr,
          lockerId: vm.sendInfo.lockerId,
        }

        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false

          } else {
            if(vm.newStatus === '04') {
              vm.callSendHoldMailApi()
            } else if (vm.newStatus === '05') {
              vm.callSendCancelMailApi()
            } else if (vm.newStatus === '99') {
              kendo.alert('배송사 전달 확인 메일 발송 후 상태 변경 되었습니다.')
              vm.redirectToList()
            }
          }
        })
      })
          .fail(() => {

            // 새로고침
            vm.getSendDetail()
          })
    },
    getStatusUpdateData (blNo, cost, sendMailAddr=null) {
      const vm = this
      kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {

        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendStateChange.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          sendId: vm.sendInfo.sendId,
          sendScn: vm.sendInfo.sendScn,
          newStatus: vm.newStatus, // 상태 변경 이후 상태 코드
          blNo: blNo,
          cost: cost,
          sendMailAddr: sendMailAddr,
        }

        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            // api 오류 응답이 오면 팝업 다시 띄우기
            if(vm.sendInfo.sendScn === '01' && vm.sendInfo.status === '01') {
              vm.$refs.requiredInfoForRegiRef.$refs.kendoWindowRef.kendoWidget().center().open()
            }
            kendo.alert(resultStatus.messageText)
            return false

          } else {
            if (vm.newStatus === '99') {
              kendo.alert('배송사 전달 확인 메일 발송 후 상태 변경 되었습니다.')
            } else {
              kendo.alert('상태 변경 되었습니다.')
            }
            vm.redirectToList()
          }
        })
      })
      .fail(() => {
        // 새로고침
        vm.getSendDetail()
      })
    },
    updateReserveCancel () {
      const vm = this
      kendo.confirm("해당 건을 상태변경하시겠습니까?").done(() => {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendStateChange.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          sendId: vm.sendInfo.sendId,
          newStatus: vm.newStatus
        }

        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          } else {
            kendo.alert('상태 변경 되었습니다.')
            vm.redirectToList() // 목록으로 리다이렉트
          }
        })
      })
          .fail(() => {
            vm.getSendDetail()
          })
    },
    callSendHoldMailApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendHoldMail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus

        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        } else {
          kendo.alert('보류 확인 메일 발송 후 상태 변경 되었습니다.')
          vm.redirectToList()
          return true
        }
      })
    },
    callSendCancelMailApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendCancelMail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus

        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        } else {
          kendo.alert('발신 취소 확인 메일 발송 후 상태 변경 되었습니다.')
          vm.redirectToList()
          return true
        }
      })
    },
    sendUpdate () {
      const vm = this
      if (!vm.isSU && vm.sendInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      if (EtnersCommonUtil.isNotEmpty(vm.sendInfo.lockerCellId)) {
        kendo.alert('무인보관함에 보관중인 물품은 수정이 불가능합니다.')
        return
      }
      this.$router.push({
        name: "SendUpdate",
        params: {
          sendId: vm.sendInfo.sendId,
        }
      })
    },
    redirectToList () {
      // 목록으로 이동
      this.$router.push({
        name: "ManageSendList"
      })
    },
    sendDelete () {
      const vm = this
      if (!vm.isSU && vm.sendInfo.status !== '00' && vm.sendInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      if (EtnersCommonUtil.isNotEmpty(vm.sendInfo.lockerCellId)) {
        kendo.alert('무인보관함에 보관중인 물품은 삭제가 불가능합니다.')
        return
      }
      kendo.confirm('해당 건을 삭제하시겠습니까?').done(function () {
          const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendDelete.json`
          const param = {
            loginUserToken: vm.loginUserToken,
            sendId: vm.sendInfo.sendId,
          }
          ApiUtil.post(url, param).then(response => {
            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
              return false
            }
            const resultStatus = response.data.resultStatus
            if (resultStatus.messageCode !== '2000') {
              kendo.alert(resultStatus.messageText)
              return false
            } else {
              kendo.alert('삭제되었습니다.')
              vm.redirectToList()
              return true
            }
          })
      })
    },
    getHistoryList () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/item/historyList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        taskGbn: 'S',
        taskId: vm.$route.params.sendId
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.historyList = response.data.resultData
      })
    },
  },
  data () {
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      propSendId : this.$route.params.sendId,
      fileSrc: null,
      sendInfo: {},
      newStatus: null,
      historyList: [],
    }
  }
}
</script>

<style scoped>

</style>
